// test2243
(2243 && 0);
